<template>

  <div v-if="customer">

    <h1>Customer: {{ customer.first_name }} {{ customer.last_name }}</h1>

    <div class="box">

      <form class="form" v-on:submit.prevent="updateCustomer" v-if="customer">
        <Errors/>
        <CustomerFields />
        <div class="form-wrap form-submit">
          <div class="mt-1" v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div class="mt-1" v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update customer</span></button>
          </div>
        </div>
      </form>

    </div>

    <template v-if="customer.bookings && customer.bookings.length > 0">
      <h2>Bookings for {{customer.first_name}} {{customer.last_name}}</h2>
      <div class="box">
        <table class="table" cellspacing="0" cellpadding="0" v-if="customer.bookings">
          <thead v-if="customer.bookings.length > 0">
            <tr>
              <th>Booking ref</th>
              <th>Date booked</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="booking of customer.bookings" :key="booking.id">
              <td><router-link :to="{ name: 'booking-edit', params: { id: booking.id }}">{{ booking.booking_ref || booking.old_booking_id }}</router-link></td>
              <td>{{ booking.created_at | formatDateTime }}</td>
              <td class="table-action"><a v-on:click="viewBooking(booking.id)" class="icon icon--more">View</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <h2>Notes</h2>
    <div class="box">
      <table class="table" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
                <th></th>
                <th>Date</th>
                <th>Time</th>
                <th>Note</th>
            </tr>
          </thead>
          <tbody>
              <template v-if="customer.notes.length > 0">
                  <tr :key="notes.id" v-for="(notes, index) in customer.notes">
                      <td>{{ index+1 }}</td>
                      <td>{{ notes.note_date }}</td>
                      <td>{{ notes.note_time }}</td>
                      <td>{{ notes.note }}</td>
                  </tr>
              </template>
              <template v-else>
                  <tr>
                      <td colspan="4" class="text-center">No Notes Found</td>
                  </tr>
              </template>
          </tbody>
      </table>
    </div>

    <h2>Brochure requests</h2>
    <BrochureRequests :customer="customer"></BrochureRequests>

    <div class="d-flex justify-content-between align-items-end">

      <h2>Bookings</h2>
      <div class="mb-2 me-1">
        <button class="button button--small" type="button" @click="createBooking" v-if="userRole == 1"><span>Create Booking</span></button>
      </div>

    </div>
    <CustomerBookings :customer="customer"></CustomerBookings>

  </div>

</template>

<script>
import BrochureRequests from '@/components/BrochureRequests.vue'
import CustomerFields from '@/components/CustomerFields.vue'
import CustomerBookings from '@/components/CustomerBookings.vue'
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerEdit',
  components: {
    CustomerFields,
    BrochureRequests,
    CustomerBookings,
    Errors
  },
  data () {
    return {
      customer: null,
      countries: [],
      referrers: null,
      errors: null,
    }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole () {
      return localStorage.getItem("user_role");
    }
  },
  created () {
    this.getCustomer()
  },
  watch: {
    '$route': 'getCustomer'
  },
  methods: {
    getCustomer () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'customers/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.customer = response.data[0]
        if(this.customer.old_bookings.length > 0) this.customer.bookings = this.customer.bookings.concat(this.customer.old_bookings)
        this.$store.dispatch('setLoadStatus')
      })
    },
    updateCustomer () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'customers/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.customer),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    viewBooking(data) {
      this.$router.push({ name: 'booking-edit', params: { id: data }})
    },
    createBooking() {
      this.$router.push({ path: '/bookings/create', query: { customer_id: this.$route.params.id, }})
    }
  },
}
</script>
